// extracted by mini-css-extract-plugin
export default {"clipPath":"HomeInfo_clipPath__PKpKr","circleTrans":"HomeInfo_circleTrans__zBb+m","btn":"HomeInfo_btn__8lNpy"};